import { ApiSearchQuery } from '@/lib/api/api-type-helper';
export type GetIssuingOrganizationsParams = ApiSearchQuery<'/v2/issuing-organizations', 'get'>;
export type OrderBy = Exclude<GetIssuingOrganizationsParams['orderBy'], undefined>;
export const ORDER_BY = {
  issuerOrganizationName: 'issuerOrganizationName',
  organizationType: 'organizationType'
} satisfies Record<string, OrderBy>;